import React from 'react';

const Loading = () => {
    return (
        <center>
            <div className="flex justify-center items-center">
                <div className="animate-spin rounded-full h-20 w-20 border-t-4 border-blue-500"></div>
            </div>
        </center>
    );
};

export default Loading;